import React from "react";
import { InfoCircleOutlined, SwapOutlined } from "@ant-design/icons";
import { Alert, Tooltip } from "antd";
import { Link } from "umi";
import { DealerExchangeType, DealerExchangeTypeMap } from "@/utils/enum";

export const exchangeTypeAndToolTip = exchangeType => {
  return (
    <Tooltip
      title={
        exchangeType === DealerExchangeType.Ordered
          ? `Requires the first leg of the exchange to be delivered before the second leg can be picked up.`
          : `Allows both legs of the exchange to be dispatched, picked up, and delivered in any order.`
      }
      overlayInnerStyle={{ backgroundColor: "white" }}
    >
      <InfoCircleOutlined style={{ marginLeft: 5 }} />
    </Tooltip>
  );
};

const DealerExchangeAlert = ({ relativeUrl, shipmentId, loadId, exchangeType, isChild, isRequired, style }) => {
  let urlId = shipmentId;
  let urlIdType = "shipment";

  if (loadId) {
    urlId = loadId;
    urlIdType = "load";
  }

  return (
    <Alert
      message={
        <div>
          {`This ${urlIdType} is part of an `}
          <strong>{`${DealerExchangeTypeMap[exchangeType]}`}</strong>
          {exchangeTypeAndToolTip(exchangeType)}
          {isRequired ? " and required" : ""}
          {` dealer exchange`}
        </div>
      }
      description={
        <div>
          <>
            <span>{`View the ${isChild ? "first" : "second"} leg of the exchange `}</span>
            <Link to={`${relativeUrl}?${urlIdType}Id=${urlId}`} target="_blank" rel="noopener noreferrer">
              here
            </Link>
          </>
        </div>
      }
      type="info"
      showIcon
      icon={<SwapOutlined />}
      style={style}
    />
  );
};

export default DealerExchangeAlert;
